import { useContext, useEffect, useState } from "react";
import { t } from "i18next";
import athletesGreenIcon from "../../assets/images/athletes.svg";
import athletesWhiteIcon from "../../assets/images/athletes-white.svg";
import { Link, useNavigate } from "react-router-dom";
import 'moment/locale/es';
import { getAthlete } from "../../services/athlete";
import { Athlete, AthleteTeamSeason } from "../../interfaces/athlete";
import { getSeasonCurrent, getSeasonOptions } from "../../services/season";
import { LoadingSpinner } from "../general/loading-spinner";
import { UserContext } from "../../App";
import statisticsWhiteIcon from "../../assets/images/statistics-white.svg";

export function AthletesMini() {
    const navigate = useNavigate();

    const { userProfile } = useContext(UserContext);

    const [athletes, setAthletes] = useState<any[]>([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        Promise.all([
            getSeasonCurrent(),
            getSeasonOptions(),
        ]).then(response => {
            if (response[0].data.id !== undefined) {
                getAthlete('', '', '', response[0].data.id)
                    .then(responseAthlete => {
                        setAthletes(responseAthlete.data);
                        setLoaded(true);
                    });
            } 
        })
        .catch(error => {
            localStorage.removeItem('token');
            navigate("/");
        });
    }, []);

    return (
        <div className="block block-athletes-mini">
            <div className="block-inner">
                <h3 className="block-title">
                    <img src={ athletesGreenIcon } alt={ t("athletes")} />
                    { t("athletes") }
                </h3>
                <div className="block-content">
                    { !loaded && 
                        <LoadingSpinner />
                    }
                    { loaded &&
                        <div className="block-content-inner">
                            <div className="block-content-data">
                                { loaded &&
                                    athletes.slice(0, 10).map((a: Athlete) => {
                                        return (<div key={ 'athlete-' + a.id } className="athlete-tile">
                                                <div className="icon">
                                                    { a.avatar.length > 0 &&
                                                        <img src={ a.avatar[0].src } alt={ a.avatar[0].name } />
                                                    }
                                                </div>
                                                <div className="title">
                                                    <Link to={ '/athletes/' + a.id + '/view' } title={ a.name } target="_blank">
                                                        { a.name }
                                                    </Link>
                                                    { a.registered_in.length > 0 &&
                                                        <div className="teams">
                                                            {
                                                                a.registered_in.map((ats: AthleteTeamSeason) => {
                                                                    return ats.club_name + '/' + ats.team_name;
                                                                }).join(', ')
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>)
                                    })
                                }
                            </div>
                        </div>
                    }
                </div>
                <div className="block-footer">
                    { userProfile.role.filter((r: any) => r.id == 'padeltech_administrator').length > 0 &&
                        <Link to="/admin/athletes" title={ t("athletes") } className="btn btn-primary">
                            <img src={ athletesWhiteIcon } alt={ t("athletes")} /> { t("athletes") }
                        </Link>
                    }
                    { userProfile.role.filter((r: any) => r.id == 'padeltech_manager').length > 0 &&
                        <Link to="/manager/athletes" title={ t("athletes") } className="btn btn-primary">
                            <img src={ athletesWhiteIcon } alt={ t("athletes")} /> { t("athletes") }
                        </Link>
                    }
                    { userProfile.role.filter((r: any) => r.id == 'padeltech_coach').length > 0 &&
                        <Link to={ '/coach/planning/reports'} title={ t("Reports") } className="btn btn-primary">
                            <img src={ statisticsWhiteIcon } alt={ t("Reports")} /> { t("Reports") }
                        </Link>
                    }
                </div>
            </div>
        </div>
    );
}  
